import { render, staticRenderFns } from "./index.vue?vue&type=template&id=aa8e1724&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=aa8e1724&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa8e1724",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa8e1724')) {
      api.createRecord('aa8e1724', component.options)
    } else {
      api.reload('aa8e1724', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=aa8e1724&scoped=true&lang=pug&", function () {
      api.rerender('aa8e1724', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/assets/dialog/tokenInfo/index.vue"
export default component.exports